<template>
    <div class="home-header" id="home-header">
        <div class="header-box">
            <div class="header-left">
                <img class="header-left-icon" :src="iconMap" alt="">
                <div class="header-city">
                    <!--<span class="city-name">{{ cityName }}</span>
                    <span class="city-change" @click="chooseCity({id:1})">[更换]</span> -->
                    <!--:show-all-levels="false"-->
                    <el-cascader
                            size="small"
                            :options="options"
                            v-model="currentCity"
                            @change="handleChange"
                            :value="addressInfo"
                    >
                    </el-cascader>
                    <!--<selectCity
                      v-if="isShowChooseCity"
                      :isShowChooseCity="isShowChooseCity"
                      :closeFunc="closeFunc"
                      :chooseCity="chooseCity"
                      :isPy="isPy"
                      :id="id"
                      :title="title"
                    ></selectCity> -->
                    <!--<div class="city">
                        <input type="text" placeholder="出发城市" @focus="showCityDialog" @blur="hideCityDialog">
                        <div class="city-components" v-if="showCity">
                            城市控件
                        </div>
                    </div>-->
                </div>
            </div>

            <div class="header-right">
                <div class="header-login" v-if="!getuserToken">
                    <span class="login-btn" @click="headerLogin()">登录</span>
                    <span class="register-btn" @click="headerRegister()">注册</span>
                </div>
                <div class="header-login" v-else>
                    <span class="login-user-name">{{ userName }}</span>
                    <span class="register-btn" @click="logout()">退出</span>
                </div>
                <div class="header-personal" @click="toPerCenter()">个人中心</div>
                <div class="header-app">
                    <div class="header-app-span" @mouseenter="showCode()" @mouseleave="hideCode()">下载app</div>
                    <div class="apppagecodeimg" v-if="showAppCode">
                        <img :src="apppagecode" alt="">
                        <span>扫码下载乘客APP</span>
                    </div>
                </div>
                <!--<div class="header-customer">客服中心</div>-->
                <div class="header-tel">
                    <img :src="telIcon" alt="">
                    <span>400-000-8990</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        provinceAndCityData,
        regionData,
        provinceAndCityDataPlus,
        regionDataPlus,
        CodeToText,
        TextToCode
    } from 'element-china-area-data'
    import selectCity from "fcl-npm-select-city";
    import AMap from 'AMap'
    import {mapState, mapMutations, mapGetters} from 'vuex';

    export default {
        name: "homeHeader",
        components: {
            selectCity
        },
        data() {
            return {
                // options: provinceAndCityData,
                options: [],
                selectedOptions: [],
                currentCity: '',
                iconMap: require('@/assets/images/index/nav_icon_address.png'),
                cityName: '全国',
                telIcon: require('@/assets/images/index/nav_icon_phone.png'),
                // showCity: false,
                cityId: '',
                // 高德地图获取当前位置
                addressInfo: '110000',
                lat: 0,
                lng: 0,
                // title: '选择城市', //该值可按照需求修改
                // id: 1,  // 默认选择city1
                // isPy: false, //默认显示汉字
                // isShowChooseCity: false, //默认不显示该组件
                // city1: '中国香港', //城市1,可以自己设置默认城市

                apppagecode: require('@/assets/images/index/loadapppagecode.png'),
                showAppCode: false
            }
        },
        mounted() {
            var that = this;
            that.getCityData();
            // var cityId = this.$store.state.cityId;
            // var provinceName = that.$store.state.provinceName;
            // var cityName = that.$store.state.cityName;
            var cityId = that.getcityId;
            var provinceName = that.getprovinceName;
            var cityName = that.getcityName;
            var provinceId = that.getprovinceId;
            if (cityId == '' || cityId == undefined || cityId == null || provinceName == '' || provinceName == undefined || provinceName == null || cityName == '' || cityName == undefined || cityName == null) {
                // console.log('走定位')
                this.getLocation();
            } else {
                // console.log('不走定位')
                that.getTeamList(cityId);
                that.getcharterList(cityId); //获取城市车队列表
                that.currentCity = cityName;
            }
            /* if (cityId != '') {
                 that.getTeamList(cityId);
                 that.getcharterList(cityId); //获取城市车队列表
                 if (provinceName == '' || provinceName == undefined || provinceName == null || cityName == '' || cityName == undefined || cityName == null) {
                     // console.log('走定位')
                     this.getLocation();
                 } else {
                     /!*if (TextToCode[provinceName][cityName] == undefined) {
                         this.getLocation();
                     } else if ("code" in TextToCode[provinceName][cityName]) {
                         that.selectedOptions = [TextToCode[provinceName].code, TextToCode[provinceName][cityName].code]
                     }*!/
                 }
             } else {
                 this.getLocation();
             }*/
        },
        methods: {
            ...mapMutations(['saveProvinceName', 'saveCityName', 'saveCity', 'saveProvinceId', 'saveProvinceCitys', 'saveTeamList', 'saveCdList', 'saveJxList', 'changeLogin', 'saveUser', 'saveTimUid', "saveLocalTeam", 'saveLocalCd']),
            showCode() {
                this.showAppCode = true;
            },
            hideCode() {
                this.showAppCode = false;
            },
            // 获取城市选择数据
            getCityData() {
                var that = this;
                that.$axios.get('/provinceAndCity', {}).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        // console.log(res.data)
                        that.options = res.data;
                    } else {
                        // layer.msg('系统错误，请刷新！', {icon: 2});
                        this.$message.error('系统错误，请刷新！');
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },
            // 头部城市选择器切换事件
            handleChange(value) {
                var that = this;
                var provinceName;
                var provinceId;
                var cityName;
                var cityId;

                /*if (value[0] == '110000' || value[0] == '120000' || value[0] == '310000' || value[0] == '500000') {
                    cityName = CodeToText[value[0]];
                } else {
                    cityName = CodeToText[value[1]];
                    provinceName = CodeToText[value[0]];
                }*/
                provinceName = value[0];
                cityName = value[1];

                that.options.forEach((item) => {
                    if (value[0].indexOf(item.value) > -1 && item.children.length) {
                        provinceId = item.id;
                        that.saveProvinceId({'provinceId': provinceId});
                        that.saveProvinceCitys(item.children);
                        return;
                        /*item.children.forEach((inItem)=>{
                            if(value[1].indexOf(inItem.value) > -1){
                                console.log(inItem)
                            }
                        })*/
                    } else {
                        // console.log('111')
                    }
                })

                that.saveProvinceName({'provinceName': provinceName});
                that.saveCityName({'cityName': cityName});

                that.$axios.post('/cityNameGetId', {
                    city_name: cityName,
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        cityId = res.data;
                        that.cityId = cityId;
                        that.saveCity({'cityId': res.data});
                        that.getTeamList(res.data);

                        var curUrl = this.$route.path;
                        if (curUrl.search('charter') != -1) {
                            // console.log("在列表页");
                            //在列表页切换城市调用列表改变方法
                            that.getcharterList(that.cityId); //获取城市车队列表
                        }
                        // that.$emit('getTeam', that.cityId); //获取本地车队列表
                    } else {
                        // layer.msg('系统错误，请刷新！', {icon: 2});
                        this.$message.error('系统错误，请刷新！');
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },

            /*hideCityDialog() {
                this.showCity = false;
            },*/
            /*showCityDialog() {
                this.showCity = true;
            },*/
            // 跳转个人中心
            toPerCenter() {
                var currentUrl = this.$route.path;
                if (currentUrl.search('persondata') != -1) {
                    return;
                } else if (this.$store.state.userToken) {
                    this.$router.push({path: 'persondata'});
                } else {
                    this.$confirm('您尚未登录，是否前往登录！', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then((res) => {
                        this.$router.push({path: 'login'});
                    }).catch(() => {

                    });
                }
            },
            // 头部登录事件
            headerLogin() {
                var curUrl = this.$route.path;
                if (curUrl.search('login') != -1) {
                    return;
                } else {
                    this.$router.push({path: '/login'});
                }
            },
            // 头部注册事件
            headerRegister() {
                var curUrl = this.$route.path;
                if (curUrl.search('login') != -1) {
                    return;
                } else {
                    this.$router.push({path: '/login'});
                }
            },
            // 头部退出登录
            logout() {
                this.$confirm('是否退出登录')
                    .then(_ => {
                        var token = this.$store.state.userToken;

                        this.$axios.get('/logOut', {
                            token: token
                        }).then((res) => {
                            this.changeLogin({userToken: ''});
                            this.saveUser({userName: ''});
                            this.saveTimUid({userTimUid: ''});
                            this.$router.push('/login');
                        }).catch((error) => {
                            this.changeLogin({userToken: ''});
                            this.saveUser({userName: ''});
                            this.saveTimUid({userTimUid: ''});
                            this.$router.push('/login');
                        });
                    })
                    .catch(_ => {
                    });
            },
            // 获取当前位置
            getLocation() {
                const self = this;
                AMap.plugin('AMap.Geolocation', function () {
                    var geolocation = new AMap.Geolocation({
                        // 是否使用高精度定位，默认：true
                        enableHighAccuracy: true,
                        // 设置定位超时时间，默认：无穷大
                        timeout: 10000
                    });

                    geolocation.getCurrentPosition();
                    AMap.event.addListener(geolocation, 'complete', onComplete);
                    AMap.event.addListener(geolocation, 'error', onError);

                    function onComplete(data) {
                        // data是具体的定位信息
                        // console.log('定位成功信息：', data.addressComponent.province);
                        // console.log('定位成功信息：', data.addressComponent.city);
                        // self.$options.methods.saveCityNameZz(data.addressComponent.city);
                        // console.log('定位成功信息：', TextToCode[data.addressComponent.province].code);
                        // console.log('定位成功信息：', TextToCode[data.addressComponent.province][data.addressComponent.city].code);
                        // self.$store.state.cityName = data.addressComponent.city;

                        self.saveProvinceName({'provinceName': data.addressComponent.province})
                        self.saveCityName({'cityName': data.addressComponent.city})
                        self.cityameToId(data.addressComponent.city);
                        self.provinceToId(data.addressComponent.province);
                        self.currentCity = data.addressComponent.city;
                        /*if ("code" in TextToCode[data.addressComponent.province][data.addressComponent.city]) {
                            self.selectedOptions = [TextToCode[data.addressComponent.province].code, TextToCode[data.addressComponent.province][data.addressComponent.city].code]
                        }*/
                    }

                    function onError(data) {
                        // 定位出错
                        console.log('定位失败错误：', data);
                        // 调用IP定位
                        self.addressInfo = '获取定位失败...';
                        // 定位失败就默认显示厦门
                        self.selectedOptions = [350000, 350200];


                        // 默认厦门车队资料
                        self.saveProvinceName({'provinceName': '福建省'})
                        self.saveCityName({'cityName': '厦门市'})
                        self.cityameToId('厦门市');
                        self.provinceToId('福建省');
                        self.currentCity = '厦门市';
                    }
                });
            },
            // 通过IP获取当前位置
            getLngLatLocation() {
                AMap.plugin('AMap.CitySearch', function () {
                    var citySearch = new AMap.CitySearch();
                    citySearch.getLocalCity(function (status, result) {
                        if (status === 'complete' && result.info === 'OK') {
                            // 查询成功，result即为当前所在城市信息
                            // console.log('通过ip获取当前城市：', result);
                            // 逆向地理编码
                            AMap.plugin('AMap.Geocoder', function () {
                                var geocoder = new AMap.Geocoder({
                                    // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                                    city: result.adcode
                                });

                                var lnglat = result.rectangle.split(';')[0].split(',');
                                geocoder.getAddress(lnglat, function (status, data) {
                                    if (status === 'complete' && data.info === 'OK') {
                                        // result为对应的地理位置详细信息
                                        console.log(data);
                                    }
                                });
                            });
                        }
                    });
                });
            },

            // 定位城市转id
            cityameToId(cityName) {
                var that = this
                that.$axios.post('/cityNameGetId', {
                    city_name: cityName,
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        that.saveCity({'cityId': res.data});
                        that.getTeamList(res.data);
                        that.getcharterList(res.data);
                    } else {
                        // layer.msg('系统错误，请刷新！', {icon: 2});
                        this.$message.error('系统错误，请刷新！');
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },


            provinceToId(provinceName){
                var that = this;
                var provinceId;
                that.options.forEach((item) => {
                    if (provinceName.indexOf(item.value) > -1) {
                        provinceId = item.id;
                        that.saveProvinceId({'provinceId': provinceId});
                        return;
                    } else {
                        // console.log('111')
                    }
                })
            },

            // 获取本地车队列表
            getTeamList(id) {
                var that = this;
                if (id != '') {
                    that.$axios.post('/getLocalTeam', {
                        city_id: id
                    }).then((res) => {
                        res = res.data;
                        if (res.status == 200) {
                            // console.log(res.data);
                            that.saveLocalTeam({'localTeam': res.data});
                            that.saveLocalCd({'localCd': res.data});
                        } else {
                            // layer.msg('数据获取失败，请刷新！', {icon: 2});
                            this.$message.error('数据获取失败，请刷新！');
                        }
                    }).catch((error) => {
                        console.log(error);
                    });
                } else {
                    // layer.msg('请选择城市！');
                    this.$message('请选择城市！');
                }
            },

            // 车队列表
            getcharterList(id) {
                var that = this;
                if (id != '') {
                    that.$axios.post('/charterList', {
                        city_id: id,
                        page: 1
                    }).then((res) => {
                        res = res.data;
                        if (res.status == 200) {
                            that.saveTeamList({'saveTeamList': res.data});
                            that.saveCdList({'saveCdList': res.data});
                            that.saveJxList({'jxList': res.data.slice(0, 4)});
                        } else {
                            // layer.msg('数据获取失败，请刷新！', {icon: 2});
                            this.$message.error('数据获取失败，请刷新！');
                        }
                    }).catch((error) => {
                        console.log(error);
                    });
                } else {
                    // layer.msg('请选择城市！');
                    this.$message.error('请选择城市！');
                }
            },

        },
        computed: {
            ...mapGetters(['getprovinceName', 'getcityName', 'getcityId', 'getuserToken']),
            userName() {
                return this.$store.state.userName;
            },
        },
    }
</script>

<style scoped>
    .home-header {
        width: 100%;
        min-width: 1200px;
        height: 30px;
        background: #F5F5F5;
    }

    .header-box {
        width: 1200px;
        height: 30px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .header-left {
        display: flex;
        flex: 1;
        align-items: center;
    }

    .header-left-icon {
        width: 16px;
        height: 16px;
        margin-right: 8px;
    }

    .header-city {
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        display: flex;
        flex: 1;
        align-items: center;
    }

    .city-name {
        max-width: 100px;
        height: 30px;
        line-height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .city-change {
        cursor: pointer;
        height: 30px;
        line-height: 30px;
        width: 45px;
        text-align: center;
    }

    .header-city >>> .el-input__inner {
        margin: 0;
        padding-right: 20px;
        height: 30px;
        line-height: 30px;
        border: none;
        background: none;
        width: 133px;
        color: #666;
        padding-left: 0;
    }

    .header-right {
        height: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .header-login {
        height: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .login-btn, .register-btn {
        width: 45px;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
        text-align: center;
        color: #666666;
        font-size: 12px;
    }

    .login-user-name {
        min-width: 45px;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
        text-align: center;
        color: #666666;
        font-size: 12px;
    }

    .header-personal, .header-app-span, .header-customer {
        width: 80px;
        height: 16px;
        line-height: 16px;
        border-left: 1px solid #c9c9c9;
        text-align: center;
        font-size: 12px;
        color: #666;
        cursor: pointer;
    }

    .header-app {
        position: relative;
    }

    .apppagecodeimg {
        width: 180px;
        height: 180px;
        position: absolute;
        top: 23px;
        left: 0;
        z-index: 100;
        background: #fff;
    }

    .apppagecodeimg img {
        display: block;
        margin: 10px auto 5px;
        width: 140px;
        height: 140px;
    }

    .apppagecodeimg span {
        display: block;
        text-align: center;
        margin: 0 auto;
    }

    .header-tel {
        height: 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        border-left: 1px solid #c9c9c9;
    }

    .header-tel img {
        width: 16px;
        height: 16px;
        margin-left: 12px;
        margin-right: 10px;
    }

    .header-tel span {
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-style: italic;
        color: #FF5227;
    }

</style>



// WEBPACK FOOTER //
// src/components/homeHeader.vue